exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left-nav {\n  position: fixed;\n  left: 0;\n  top: 60px;\n  height: 100%;\n  width: 70px;\n  background-color: #0c0c2c;\n  text-align: center;\n  z-index: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/left-nav/left-nav.scss
// module id = ../../../../../src/app/shared/components/left-nav/left-nav.scss
// module chunks = 12